import { recursiveClosest } from './recursive-closest';

/**
 * The ng-bootstrap library uses Element.prototype.closest. In older versions of
 * edge this is not available and will crash.
 *
 * The code is based on the polyfill referenced by developer.mozilla.com.
 * You can find that here: https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */

if (!Element.prototype.matches) {
  // eslint-disable-next-line @typescript-eslint/dot-notation
  Element.prototype.matches = Element.prototype['msMatchesSelector']
    || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (selector: string) {
    return recursiveClosest(selector, this);
  };
}
